'use client';
import AppLayout from '@/components/AppLayout';
import InvestorAccountScreen from './components/InvestorAccountScreen';

export default function InvestorAccountPage() {
  return (
    <AppLayout portalName="Investor Portal" portalRole="investor">
      <InvestorAccountScreen />
    </AppLayout>
  );
}
